import { AskRequest, AskResponse, ChatRequest, NewChatRequest, DocumentsResponse, ChatCreateResponse } from "./models";

export async function createChat(producto: string, userId: string, userName: string): Promise<ChatCreateResponse> {
    const response = await fetch(`/create_chat`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            item_id: producto,
            user_id: userId,
            user_name: userName,
            name: "Chat de prueba",
            configuration_id: "DEFAULT"
        })
    });
    const parsedResponse: ChatCreateResponse = await response.json();
    if (response.status > 299 || !response.ok) {
        throw Error("Unknown error");
    }

    return parsedResponse;
}

export function getCitationFilePath(citation: string): string {
    return `/content/${citation}`;
}

export async function chatApiV2(options: NewChatRequest): Promise<AskResponse> {
    const response = await fetch("/chat_v2", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            chat_id: options.chat_id,
            message: options.message
        })
    });

    const parsedResponse: AskResponse = await response.json();
    if (response.status > 299 || !response.ok) {
        throw Error(parsedResponse.error || "Unknown error");
    }

    return parsedResponse;
}

export async function uploadImage(chatId: string, file: File, message: string): Promise<AskResponse> {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("chat_id", chatId);
    formData.append("message", message);

    const response = await fetch("/upload_image", {
        method: "POST",
        body: formData
    });

    const parsedResponse: AskResponse = await response.json();
    if (response.status > 299 || !response.ok) {
        throw Error(parsedResponse.error || "Unknown error");
    }

    return parsedResponse;
}

export interface FeedbackPayload {
    user_id: string;
    type?: "like" | "dislike";
    comment?: string;
    message_id: string;
    chat_id?: string;
}

export async function createFeedback(payload: FeedbackPayload) {
    const res = await fetch("/create_feedback", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
    });
    if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.error || "No se pudo crear el feedback");
    }
    return res.json();
}
